import { DataModel } from "common/models/utility-models/base-model";

export class OtpModel extends DataModel {
    otp: string = "";
    userType: string = "";
    token: string = "";
    status: string = "";
    isTermFlag: any = '';
    email: any = '';
    expiry_time: any = "";
    first_name: any = "";
    override id: any = "";
    last_name: "";
    name: any = "";
    profile_pic_name: any="";
    role: any = "";
    time: any = "";  
    isProfileUpdateFlag:any=0; 
    api_access_tokon: any = '';
}